// extracted by mini-css-extract-plugin
module.exports = {"submitWrapper":"CustomerInformationForm__submitWrapper___1S41n AccountPage__submitWrapper___22KMu"};